import axios from "axios";
import config from "../config";

// axios default configs
const _Api = axios.create({
    baseURL: config.api_base_url,
    withCredentials: true
});

_Api.interceptors.response.use(
    (response) => {
        const serverVersion = response.headers['app-version'];
        const localVersion = localStorage.getItem("tizemilyon_version");

        if (serverVersion && localVersion && serverVersion !== localVersion) {
            localStorage.setItem("tizemilyon_version", serverVersion);
            localStorage.setItem("show_update_notice", "true");
            
            // Force clear caches and unregister SW
            if ("caches" in window) {
                caches.keys().then(names => Promise.all(names.map(n => caches.delete(n))));
            }
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.getRegistrations().then(regs => Promise.all(regs.map(r => r.unregister())));
            }
            
            // Reload after a short delay to ensure storage is updated
            setTimeout(() => {
                window.location.reload(true);
            }, 500);
        }
        return response;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default _Api;
